import Omy from "../omy/Omy";

/**
 * @desc Namespace for use functional of POEditor
 * @namespace POEditor
 * @memberOf OMY
 */

export default {
    /**
     * @desc API Token to POEditor project
     * @type {?string}
     */
    apiToken: null,
    /**
     * @desc Key of application
     * @type {?int}
     */
    key: null,
    /**
     * @desc Languages keys (For example ru_RU, fr_FR).
     * @type {?string[]}
     */
    languages: null,
    /**
     * @desc Languages id's (For example ru, pt, en).
     * @type {?string[]}
     */
    languageIds: null,

    /**
     * @desc Key of game. Need to parse localization (For  example "rg_ld").
     * @type {?string}
     */

    gameKey: null,

    /**
     * @desc Dictionary with locales.
     * @type {Object.<PIXI.LoaderResource>}
     */

    localeDictionary: {},

    /**
     * @desc Load language from POEditor and add it to resources.
     * @function
     * @param {string} language
     * @param {Function} callback
     * @param {Object} context
     */

    loadLanguage: function (language, callback, context) {
        if (
            this._checkEmpty(this.apiToken, "API Token") ||
            this._checkEmpty(this.key, "Key") ||
            this._checkEmpty(this.languages, "Languages") ||
            this._checkEmpty(this.languageIds, "Language id's") ||
            this._checkEmpty(this.gameKey, "Game key")
        ) {
            return;
        }

        const index = this.languages.indexOf(language);

        if (index === -1) {
            Omy.error("POEditor: language " + language + " don't set.");
            return;
        }

        const onLoadComplete = () => {
            Omy.resources["language"] = this.localeDictionary[this.languageIds[index]];
            callback.call(context);
        };

        if (Object.keys(this.localeDictionary).length === 0) {
            this._loadLanguages(onLoadComplete, this);
            return;
        }
        onLoadComplete();
    },

    _loadLanguages(callback, context) {
        let langIndex = 0;
        const langCount = this.languageIds.length;
        const loadLanguage = () => {
            ++langIndex;
            if  (langIndex === langCount) {
                callback.call(context);
                return;
            }
            this._loadLanguage(this.languageIds[langIndex], loadLanguage, this);
        };
        this._loadLanguage(this.languageIds[langIndex], loadLanguage, this);
    },

    _loadLanguage(language, callback, context) {
        const request = new XMLHttpRequest();
        request.open("POST", "https://api.poeditor.com/v2/terms/list", true);
        request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

        const params = "api_token=" + this.apiToken + "&id=" + this.key + "&language=" + language;

        request.onreadystatechange = () => {
            if (request.readyState !== 4) {
                return;
            }
            if (request.status === 200) {
                const responseData = JSON.parse(request.responseText);
                const terms = responseData.result.terms;
                const localization = {};
                const termCount = terms.length;
                const gameKeySize = this.gameKey.length;
                let i, term, key;

                for (i = 0; i < termCount; ++i) {
                    term = terms[i];
                    key = term.term;
                    if (key.indexOf(this.gameKey) !== 0) {
                        continue;
                    }
                    localization[key.substr(gameKeySize + 1, key.length - gameKeySize - 1)] = term.translation.content;
                }
                this.localeDictionary[language] = {
                    extension: "json",
                    data: localization,
                    name: "language",
                    url: "https://api.poeditor.com",
                    xhrType: "json",
                    progressChunk: 100,
                    loadType: 1,
                    error: 0,
                };
                callback.call(context);
                return;
            }

            Omy.error("Failed to load localization: " + request.responseText);
        };
        request.send(params);
    },

    /**
     * @desc Check is data empty, and log error.
     * @function
     * @param {*} data
     * @param {string} warn
     * @return {boolean}
     * @private
     */

    _checkEmpty(data, warn) {
        if (data === null) {
            Omy.error("POEditor: " + warn + " empty");
            return true;
        }
        return false;
    }
};
